import React from 'react';
import Localize from 'react-intl-universal';
import { useLocation } from 'react-router-dom';

import { BOOKING_PROCESS } from '@common/network';
import BadUrlMessage from '@components/BadUrlMessage/BadUrlMessage';
import ConfirmationPage from '@components/ConfirmationPage/ConfirmationPage';
import useConfirmation from '@hooks/Confirmation/useConfirmation';

const ParticipantConfirmation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const participantUuid = queryParams.get('participant');

  const {
    isLoading,
    open,
    errorMessage,
    isInvalidUrl,
    confirmMessage,
    participant,
    approvalNeeded
  } = useConfirmation(participantUuid, BOOKING_PROCESS.PARTICIPANT_CONFIRMATION);

  if (isInvalidUrl) {
    return <BadUrlMessage />;
  }

  return (
    <ConfirmationPage
      confirmMessage={confirmMessage}
      approvalNeeded={approvalNeeded}
      errorMessage={errorMessage}
      headline1={`${Localize.get('Confirmation.participantSuccess1', {
        firstName: `${participant?.firstName}`,
        lastName: `${participant?.lastName}`
      })} ${Localize.get('Confirmation.participantSuccess2')}`}
      headline3={Localize.get('Confirmation.invalidTokenMessage')}
      isLoading={open || isLoading}
    />
  );
};

export default ParticipantConfirmation;
